import * as React from 'react';
import { ArticleHeading4 } from '@cian/ui-kit';

import * as styles from './TitleField.css';

interface ITitleFieldProps {
  url: string;
  onClick?(e?: React.MouseEvent<HTMLAnchorElement>): void;
}

export const TitleField: React.FC<React.PropsWithChildren<ITitleFieldProps>> = ({ url, onClick, children }) => {
  return (
    <ArticleHeading4>
      <a href={url} target="_blank" rel="noreferrer" onClick={onClick} className={styles['link']}>
        {children}
      </a>
    </ArticleHeading4>
  );
};
